import config from 'config';

export const CLOUDINARY_PATH = config.get<string>('public.imageProvider.cloudinary.path');
export const CLOUDINARY_DIR = config.get<string>('public.imageProvider.cloudinary.dir');
export const CLOUDINARY_URL = `${CLOUDINARY_PATH}/v1652263914/${CLOUDINARY_DIR}`;
